var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"book"}},[_c('ul',_vm._l((_vm.contents),function(book,index){return _c('li',{ref:"li",refInFor:true},[_c('img',{attrs:{"src":book}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }